import { ConsultantFormData } from '@/types/consultant-registration.types';

const STORAGE_KEY = 'consultant_registration_draft';

// =====================================================
// LOCAL STORAGE HELPERS
// =====================================================

export function saveFormToLocalStorage(formData: ConsultantFormData, step: number): void {
  try {
    const dataToSave = {
      formData,
      step,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(dataToSave));
  } catch (error) {
    console.error('Error saving form to localStorage:', error);
  }
}

export function loadFormFromLocalStorage(): { formData: ConsultantFormData; step: number } | null {
  try {
    const savedData = localStorage.getItem(STORAGE_KEY);
    if (savedData) {
      return JSON.parse(savedData);
    }
  } catch (error) {
    console.error('Error loading form from localStorage:', error);
  }
  return null;
}

export function clearFormFromLocalStorage(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing form from localStorage:', error);
  }
}

// =====================================================
// API SUBMISSION
// =====================================================

export interface SubmissionResponse {
  success: boolean;
  message?: string;
  data?: any;
}

export async function submitConsultantRegistration(
  formData: ConsultantFormData
): Promise<SubmissionResponse> {
  try {
    // Simulate API call
    console.log('Submitting consultant registration:', formData);

    // In production, replace with actual API call:
    // const response = await fetch('/api/consultant-registration', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify(formData),
    // });
    // return await response.json();

    // Simulate network delay
    await new Promise((resolve) => setTimeout(resolve, 1500));

    // Simulate successful response
    return {
      success: true,
      message: 'Registration submitted successfully',
      data: {
        consultantId: `CONS-${Date.now()}`,
      },
    };
  } catch (error) {
    console.error('Error submitting consultant registration:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

// =====================================================
// ADDRESS COMPONENTS (simplified without Google Maps)
// =====================================================

export interface AddressComponents {
  streetAddress: string;
  city: string;
  stateProvince: string;
  zipPostalCode: string;
  country: string;
}
